import React from 'react';

interface Props {
  children: React.ReactNode;
  color?: string;
  className?: string;
}

export function Eyebrow({ children, color = '#1B5E20', className }: Props) {
  return (
    <span
      className={['inline-block uppercase font-bold', className || ''].join(' ').trim()}
      style={{
        fontSize: 10,
        letterSpacing: '0.18em',
        color,
      }}
    >
      {children}
    </span>
  );
}
